import { j as o } from "../../jsx-runtime-CZlWR0BA.js";
import { U as s, H as n, C as i } from "../../styled-components.browser.esm-cBExeaUK.js";
import { useEffect as u } from "react";
import { u as p, n as m } from "../../notification-Bc205vzX.js";
const f = s`
  0% {transform: translate3d(0,200%,0) scale(.6); opacity:.5;}
  100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, h = s`
  0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
  100% {transform: translate3d(0,150%,-1px) scale(.6); opacity:0;}
`, x = n.div`
  border: 1px solid ${(t) => t.theme.colorNeutralMedium};
  box-shadow: ${(t) => t.theme.shadowDown02};
  border-radius: ${(t) => t.theme.borderRadiusMd};
  background-color: ${(t) => t.theme.colorNeutralLightest};
  overflow: hidden;
  width: calc(min(90vw, 340px));
  animation-fill-mode: forwards;

  ${(t) => t.visible === !0 && i`
      animation: 200ms ${f};
    `}
  ${(t) => t.visible === !1 && i`
      animation: 200ms ${h};
      opacity: 0;
    `}
`, g = n.div`
  padding: ${(t) => t.theme.spacingStackXxxsRem};
  padding-top: 0;
  display: flex;
  align-items: center;
  ${(t) => t.variant === "inline" && i`
      flex-flow: row no-wrap;
      gap: ${(e) => e.theme.spacingStackXxxsRem};
    `}
  ${(t) => t.variant === "stacked" && i`
      flex-flow: row wrap;
      gap: ${(e) => e.theme.spacingStackXxsRem};
    `}
`, $ = n.span`
  font-family: ${(t) => t.theme.fontFamilyRegular};
  font-size: ${(t) => t.theme.fontSizeNano};
  line-height: ${(t) => t.theme.lineHeightConfy};
  flex-grow: 1;
`, b = n.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`, y = n.button`
  border: none;
  font-family: ${(t) => t.theme.fontFamilySemibold};
  font-weight: ${(t) => t.theme.fontWeightSemibold};
  color: ${(t) => t.theme.brandPrimaryMedium};
  background-color: transparent;
  padding: ${(t) => t.theme.spacingInsetXs};
  cursor: pointer;

  &::focus {
    outline: none;
  }
`, w = s`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`, k = n.div`
  width: 0;
  height: ${(t) => t.theme.spacingStackQuarck};
  border-radius: ${(t) => t.theme.borderRadiusMd};
  margin-bottom: ${(t) => t.theme.spacingStackXxxsRem};
  ${(t) => t.duration && t.visible === !0 && i`
      animation: ${w};
      animation-duration: ${t.duration}ms;
      animation-timing-function: linear;
    `}

  ${(t) => t.type === "success" && i`
      background-color: ${(e) => e.theme.colorSupportPositiveMedium};
    `}
  ${(t) => t.type === "warning" && i`
      background-color: ${(e) => e.theme.colorSupportWarningMedium};
    `}
  ${(t) => t.type === "error" && i`
      background-color: ${(e) => e.theme.colorSupportNegativeMedium};
    `}
`, v = n.div`
  width: fit-content;
  z-index: 999;
  position: fixed;
  bottom: ${(t) => t.theme.spacingStackXxxsRem};
  left: 50%;
  transform: translateX(-50%);
`, S = ({
  variant: t = "inline",
  type: e = "success",
  message: a,
  action: r,
  duration: l = 500,
  visible: c = !0
}) => {
  const d = () => {
    r.cb && r.cb();
  };
  return /* @__PURE__ */ o.jsxs(x, { visible: c, children: [
    /* @__PURE__ */ o.jsx(k, { visible: c, duration: l, type: e }),
    /* @__PURE__ */ o.jsxs(g, { variant: t, children: [
      /* @__PURE__ */ o.jsx($, { children: a }),
      /* @__PURE__ */ o.jsx(b, { children: /* @__PURE__ */ o.jsx(y, { type: "button", onClick: d, children: r.text }) })
    ] })
  ] });
}, X = () => {
  const { notifications: t } = p(), e = t.length > 0 ? t[0] : null;
  return u(() => {
    let a;
    return e && (a = setTimeout(() => {
      m.dismiss();
    }, e.duration)), () => a && clearTimeout(a);
  }, [e]), /* @__PURE__ */ o.jsx(v, { children: e && /* @__PURE__ */ o.jsx(
    S,
    {
      duration: e.duration,
      message: e.message,
      action: e.action || {
        text: "Cerrar",
        cb: () => m.dismiss()
      },
      type: e.type,
      visible: e.visible
    }
  ) });
};
export {
  S as Snackbar,
  X as SnackbarGlobal
};
